module.exports = __webpack_public_path__ + "img/PROJECT_AGENDA.dad8f8dc.png";